import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Dialog, DialogActions, DialogContent, Grid, IconButton, MenuItem, Select, Typography, useMediaQuery, useTheme } from '@mui/material';
import { tokens } from '../../../theme';
import Header from '../../../components/Header';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getAssignInstaller, getElectrician, getFabricator, getliasoning } from '../../../redux/slice/assigninstaller.slice';
import { Image_URL } from '../../../utils/baseURL';

function AssignInstaller() {

  const dispatch = useDispatch();
  const theme = useTheme();
  const auth = useSelector(state => state.auth);
  const colors = tokens(theme.palette.mode);
  const lias = useSelector(state => state.assignInstaller.liasonings);
  const LiasoningD = useSelector(state => state.assignInstaller.liasonings)?.filter(v => v?.fileNo)?.filter(item => item.status === "Disabled" || item.status === undefined);

  const assgnInstllData = useSelector(state => state.assignInstaller);

  const Liasoning = assgnInstllData.userStats ? LiasoningD : LiasoningD?.filter(d => d.userData.some(x => x._id === auth.user._id));

  console.log("LiasoningDLiasoningD", LiasoningD);

  const AssignInstaller = useSelector(state => state.assignInstaller.assignInstaller);
  const AllFabricator = useSelector(state => state.assignInstaller.Fabricator);
  const AllElectrician = useSelector(state => state.assignInstaller.Electrician);







  const imgUrl = Image_URL
  const isMobileee = useMediaQuery('(max-width:500px)');

  useEffect(() => {
    dispatch(getliasoning())
    dispatch(getAssignInstaller())
    dispatch(getFabricator())
    dispatch(getElectrician())
  }, [dispatch])

  const isMobile = useMediaQuery('(max-width:1024px)');

  const navigate = useNavigate();

  const handleEdit = (LiasoningId, assignId, fabStatus, elecStatus) => {
    navigate('/admin/add-assign-installer', { state: { LiasoningId, assignId, fabStatus, elecStatus } })
  }
  const [filter, setfilter] = React.useState('All');
  const handlefilter = (event) => {
    setfilter(event.target.value);
  };

  const getStatus = (type, assignId) => {
    switch (type) {
      case 'fabricator':
        const fabricatorData = AllFabricator?.find(a => a?.assignId === assignId);
        return fabricatorData?.fabricatorDetails?.some(detail =>
          detail.fabricatorSubCatogory &&
          detail.fabricatorProductName &&
          detail.fabricatorQty
        ) ? "complete" : "pending";
      case 'electrician':
        const electricianData = AllElectrician?.find(a => a?.assignId === assignId);
        return electricianData?.electricianDetails?.some(detail =>
          detail.electricianSubCatogory &&
          detail.electricianProductName &&
          detail.electricianQty
        ) ? "complete" : "pending";
      default:
        return "pending";
    }
  };


  const filteredLiasoning = Liasoning?.filter((v) => {
    const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);

    const fabricatorStatus = getStatus('fabricator', assignInstaller?._id);
    const electricianStatus = getStatus('electrician', assignInstaller?._id);

    const isComplete = fabricatorStatus === "complete" && electricianStatus === "complete";
    const isPending = fabricatorStatus !== "complete" || electricianStatus !== "complete";

    const hasFabricator = !!assignInstaller?.Fabricator;
    const hasElectrician = !!assignInstaller?.Electrician;
    const hasAnyRole = hasFabricator || hasElectrician;

    const hasRole =
      (filter === 'Fabricator' && hasFabricator) ||
      (filter === 'Electrician' && hasElectrician) ||
      (filter === 'Complete' && isComplete) ||
      (filter === 'Pending' && isPending);

    return filter === 'All' || hasRole;
  });



  // const filteredLiasoning = Liasoning?.filter((v) => {
  //   const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);




  //   const hasRole =
  //     (filter === 'Fabricator' && assignInstaller?.Fabricator) ||
  //     (filter === 'Electrician' && assignInstaller?.Electrician) ||
  //     (filter === 'Complete' && assignInstaller?.Fabricator && assignInstaller?.Electrician) ||
  //     (filter === 'Pending' && (!assignInstaller?.Fabricator || !assignInstaller?.Electrician));

  //   const hasAnyRole = assignInstaller?.Fabricator || assignInstaller?.Electrician;

  //   return filter === 'All' ||
  //     (filter === 'Complete' && assignInstaller?.Fabricator && assignInstaller?.Electrician) ||
  //     (filter === 'Pending' && !hasAnyRole) ||
  //     hasRole;
  // });

  const totalLiasoning = Liasoning?.length || 0;
  // const pendingCount = Liasoning?.filter(v => {
  //   const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);
  //   return !assignInstaller || (!assignInstaller?.Fabricator || !assignInstaller?.Electrician);
  // }).length || 0;

  // const completeCount = Liasoning?.filter(v => {
  //   const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);
  //   return assignInstaller && (assignInstaller?.Fabricator && assignInstaller?.Electrician);
  // }).length || 0;



  const pendingCount = Liasoning?.filter(v => {
    const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);

    const fabricatorStatus = getStatus('fabricator', assignInstaller?._id);
    const electricianStatus = getStatus('electrician', assignInstaller?._id);

    return fabricatorStatus !== "complete" || electricianStatus !== "complete";
  }).length || 0;

  const completeCount = Liasoning?.filter(v => {
    const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);

    console.log("assignInstallerassignInstaller", assignInstaller);


    const fabricatorStatus = getStatus('fabricator', assignInstaller?._id);
    const electricianStatus = getStatus('electrician', assignInstaller?._id);

    return fabricatorStatus === "complete" && electricianStatus === "complete";
  }).length || 0;


  const fabricatorCount = Liasoning?.filter(v => {
    const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);
    return assignInstaller?.Fabricator;
  }).length || 0;

  const electricianCount = Liasoning?.filter(v => {
    const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);
    return assignInstaller?.Electrician;
  }).length || 0;


  const [openView, setOpenView] = React.useState(false);
  const [viewData, setViewData] = useState(null);
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleCloseView = () => {
    setOpenView(false);
  };

  const handleview = (type, id) => {
    const fabricatorData = AllFabricator?.find(a => a?.assignId === id);
    const electricianData = AllElectrician?.find(a => a?.assignId === id);


    if (type === 'fabricator') {
      setViewData({ type: 'fabricator', ...fabricatorData });
    } else if (type === 'electrician') {
      setViewData({ type: 'electrician', ...electricianData });
    }
    setOpenView(true);
  }





  const fData = assgnInstllData.userStats ? filteredLiasoning.filter(a => a.fileNo) : filteredLiasoning.filter(a => a.fileNo)?.filter(d => d.userData.some(x => x._id === auth.user._id));

  return (
    <Box m="2px" sx={{ overflow: isMobileee ? 'auto' : 'hidden', }}>
      <Header
        title="ASSIGN TO INSTALLER"
        subtitle="Manage Your Assign To Installer Here"
      />
      <Select
        value={filter}
        onChange={handlefilter}
        displayEmpty
        sx={{
          minWidth: '100%',
          [theme.breakpoints.up('sm')]: {
            minWidth: '200px',
          },
          [theme.breakpoints.down('sm')]: {
            minWidth: '100%',
          },
          marginBottom: '20px',
          '& .MuiSelect-select': {
            padding: '8px',
            border: 'none',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#566585',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#566585',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#566585',
            borderWidth: '2px',
          },
        }}
      >
        <MenuItem value="All">All ({totalLiasoning})</MenuItem>
        <MenuItem value="Pending">Pending ({pendingCount})</MenuItem>
        <MenuItem value="Fabricator">Fabricator ({fabricatorCount})</MenuItem>
        <MenuItem value="Electrician">Electrician ({electricianCount})</MenuItem>
        <MenuItem value="Complete">Complete ({completeCount})</MenuItem>
      </Select>

      {filteredLiasoning?.length === 0 ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="50vh"
        >
          <Typography variant="h4" align="center" color="textSecondary">
            No data available
          </Typography>
        </Box>
      ) : (
        fData?.map((v) => {
          const assignInstaller = AssignInstaller?.find(a => a?.liasoningId === v?._id);


          return <div key={v._id}>
            <Box className="padding_box" sx={{
              m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2, bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD", color: theme.palette.mode === 'dark' ? 'white' : "black",
              overflowX: 'auto',
            }} key={v._id}
            >
              <Grid container item>
                {!isMobile && (
                  <>
                    <Grid item sx={{ flexGrow: 1 }}>
                      <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1, ml: 2, flexGrow: 1 }}>
                        <Box sx={{ width: '180px' }}>
                          <ul>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>File No</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Customer Name</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Address</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>City</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Contact No</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>System Size</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Dealer</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Solar PV Module</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Solar Grid Tie Inverter</li>
                          </ul>
                        </Box>
                        <Box sx={{ width: '550px' }}>
                          <ul>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.fillNo}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.ConsumerName}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.City_Village}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.Address}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.PhoneNumber}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.SystemSizeKw}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.userData?.map((a) => a.name)}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.productData?.map((a) => a.productName)}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.inverterData?.map((a) => a.productName)}</li>
                          </ul>
                        </Box>

                        <Box sx={{ width: '140px' }}>
                          <ul >
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              Fabrication
                            </li>
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              Electrician
                            </li>

                          </ul>
                        </Box>
                        <Box sx={{ width: '300px' }}>
                          <ul>
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              : &nbsp;{assignInstaller?.fabricatorData?.map((a) => a.name)}
                              <VisibilityIcon
                                fontSize="small"
                                style={{ marginLeft: '8px', cursor: 'pointer' }}
                                onClick={() => handleview('fabricator', assignInstaller?._id)}
                              />
                              &nbsp;&nbsp;&nbsp;
                              <span style={{
                                color: getStatus('fabricator', assignInstaller?._id) === 'complete' ? '#4CAF50' : '#ee2727'
                              }}>
                                {getStatus('fabricator', assignInstaller?._id)}
                              </span>
                            </li>
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              : &nbsp;{assignInstaller?.electricianData?.map((a) => a.name)}
                              <VisibilityIcon
                                fontSize="small"
                                style={{ marginLeft: '8px', cursor: 'pointer' }}
                                onClick={() => handleview('electrician', assignInstaller?._id)}
                              />
                              &nbsp;&nbsp;&nbsp;
                              <span style={{
                                color: getStatus('electrician', assignInstaller?._id) === 'complete' ? '#4CAF50' : '#ee2727'
                              }}>
                                {getStatus('electrician', assignInstaller?._id)}
                              </span>
                            </li>

                          </ul>
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', justifyContent: 'flex-end', flexGrow: 1, flexWrap: "nowrap" }}>
                            <Box sx={{ display: 'inline-block', bgcolor: '#134670', borderRadius: '50%', padding: '2px' }}>
                              <IconButton aria-label="edit" style={{ color: "white" }} onClick={() => handleEdit(v._id, assignInstaller?._id, getStatus('fabricator', assignInstaller?._id), getStatus('electrician', assignInstaller?._id))}>
                                <EditIcon />
                              </IconButton>
                            </Box>

                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  </>
                )}
                {isMobile ? (
                  <>
                    <Grid item sx={{ flexGrow: 1 }}>
                      <Box sx={{ whiteSpace: 'pre-line', display: 'flex', flexGrow: 1, ml: 2, flexGrow: 1 }}>
                        <Box sx={{ width: '180px' }}>
                          <ul>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>File No</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Customer Name</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Address</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>City</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Contact No</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>System Size</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Dealer</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Solar PV Module</li>
                            <li style={{ listStyleType: 'none', fontWeight: '600' }}>Solar Grid Tie Inverter</li>
                          </ul>
                        </Box>
                        <Box sx={{ width: '550px' }}>
                          <ul>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.fillNo}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.ConsumerName}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.City_Village}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.Address}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.PhoneNumber}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.marketData[0]?.SystemSizeKw}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.userData?.map((a) => a.name)}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.productData?.map((a) => a.productName)}</li>
                            <li style={{ listStyleType: 'none' }}>: &nbsp;{v.inverterData?.map((a) => a.productName)}</li>
                          </ul>
                        </Box>

                        <Box sx={{ width: '140px' }}>
                          <ul >
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              Fabrication
                            </li>
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              Electrician
                            </li>

                          </ul>
                        </Box>
                        <Box sx={{ width: '300px' }}>
                          <ul>
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              : &nbsp;{assignInstaller?.fabricatorData?.map((a) => a.name)}
                              <VisibilityIcon
                                fontSize="small"
                                style={{ marginLeft: '8px', cursor: 'pointer' }}
                                onClick={() => handleview('fabricator', assignInstaller?._id)}
                              />
                              &nbsp;&nbsp;&nbsp;
                              <span style={{
                                color: getStatus('fabricator', assignInstaller?._id) === 'complete' ? '#4CAF50' : '#ee2727'
                              }}>
                                {getStatus('fabricator', assignInstaller?._id)}
                              </span>
                            </li>
                            <li style={{ listStyleType: 'none', fontWeight: '600', marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                              : &nbsp;{assignInstaller?.electricianData?.map((a) => a.name)}
                              <VisibilityIcon
                                fontSize="small"
                                style={{ marginLeft: '8px', cursor: 'pointer' }}
                                onClick={() => handleview('electrician', assignInstaller?._id)}
                              />
                              &nbsp;&nbsp;&nbsp;
                              <span style={{
                                color: getStatus('electrician', assignInstaller?._id) === 'complete' ? '#4CAF50' : '#ee2727'
                              }}>
                                {getStatus('electrician', assignInstaller?._id)}
                              </span>
                            </li>

                          </ul>
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid sx={{ textAlign: 'start', marginBottom: 2, display: 'flex', justifyContent: 'flex-end', flexGrow: 1, flexWrap: "nowrap" }}>
                            <Box sx={{ display: 'inline-block', bgcolor: '#134670', borderRadius: '50%', padding: '2px' }}>
                              <IconButton aria-label="edit" style={{ color: "white" }} onClick={() => handleEdit(v._id, assignInstaller?._id)}>
                                <EditIcon />
                              </IconButton>
                            </Box>

                          </Grid>
                        </Box>
                      </Box>
                    </Grid>
                  </>

                ) : (
                  <>

                  </>
                )}
              </Grid>
            </Box >
          </div>
        })
      )}
      <Dialog
        fullScreen={fullScreen}
        open={openView}
        onClose={handleCloseView}
        aria-labelledby="responsive-dialog-title"
        maxWidth={"sm"}
        fullWidth
      >
        <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <div style={{ flex: '1' }}>
              {viewData?.type === 'fabricator' ? (
                <>
                  <h3>Fabricator Data</h3>
                  {viewData?.fabricatorDetails?.some(
                    detail => detail.fabricatorSubCatogory && detail.fabricatorProductName && detail.fabricatorQty
                  ) ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                      <thead>
                        <tr>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Category</th>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Subcategory</th>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Product Name</th>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewData?.fabricatorDetails?.map((detail, index) => {
                          const category = viewData?.categoryData?.find(cat => cat._id === detail.fabricatorCatogory);
                          const subCategory = viewData?.subCategoryData?.find(subCat => subCat._id === detail.fabricatorSubCatogory);
                          const product = viewData?.productData?.find(prod => prod._id === detail.fabricatorProductName);

                          return (
                            <tr key={index}>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {category?.categoryName || 'N/A'}
                              </td>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {subCategory?.subCategoryName || 'N/A'}
                              </td>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {product?.productName || 'N/A'}
                              </td>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {detail?.fabricatorQty || 'N/A'}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <Typography variant="h6" align="center" color="white">
                      No data available
                    </Typography>
                  )}
                </>
              ) : viewData?.type === 'electrician' ? (
                <>
                  <h3>Electrician Data</h3>
                  {viewData?.electricianDetails?.some(detail => detail.electricianSubCatogory && detail.electricianProductName && detail?.electricianQty) ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                      <thead>
                        <tr>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Category</th>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Subcategory</th>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Product Name</th>
                          <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewData?.electricianDetails?.map((detail, index) => {
                          const category = viewData?.categoryData?.find(cat => cat._id === detail.electricianCatogory);
                          const subCategory = viewData?.subCategoryData?.find(subCat => subCat._id === detail.electricianSubCatogory);
                          const product = viewData?.productData?.find(prod => prod._id === detail.electricianProductName);

                          return (
                            <tr key={index}>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {category?.categoryName || 'N/A'}
                              </td>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {subCategory?.subCategoryName || 'N/A'}
                              </td>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {product?.productName || 'N/A'}
                              </td>
                              <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                {detail?.electricianQty || 'N/A'}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <Typography variant="h6" align="center" color="textSecondary">
                      No data available
                    </Typography>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
          <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box >
  )
}

export default AssignInstaller
